import { map, pick } from 'lodash'

const transformToSaveCuisineTypesArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, [
      'id',
      'name',
      'parentId',
      'isCurationEnabled',
      'isErrorProne',
    ]),
    children: transformToSaveCuisineTypesArgs(node.children),
    position: index,
  }))

export default transformToSaveCuisineTypesArgs
